import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import Pricing from '@/components/Pricing';
import Services from '@/components/Services';
import Services2 from '@/components/Services2';
import Certifications from '@/components/Certifications';
import ServicesDIY from '@/components/ServicesDiy';
import ServicesSchedule from '@/components/ServicesSchedule';
import Contact from '@/components/Contact';
import WaterUsage from '@/components/WaterUsage';
import Payments from '@/components/Payments'

Vue.use(Router);

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Waters Contracting'
      }
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
      meta: {
        title: 'Waters Contracting - Pricing'
      }
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      meta: {
        title: 'Waters Contracting - Services'
      }
    },
    {
      path: '/services-new',
      name: 'Services-new',
      component: Services2,
      meta: {
        title: 'Waters Contracting - Services'
      }
    },
    {
      path: '/certifications',
      name: 'Certifications',
      component: Certifications,
      meta: {
        title: 'Waters Contracting - Certifications'
      }
    },
    {
      path: '/services/diy',
      name: 'ServicesDIY',
      component: ServicesDIY,
      meta: {
        title: 'Waters Contracting - Services for DIY'
      }
    },
    {
      path: '/services/schedule',
      name: 'ServicesSchedule',
      component: ServicesSchedule,
      meta: {
        title: 'Waters Contracting - Schedule a Services'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        title: 'Waters Contracting - Contact Us'
      }
    },
    {
      path: '/water_usage',
      name: 'WaterUsage',
      component: WaterUsage,
      meta: {
        title: 'Waters Contracting - Water Usage'
      }
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Payments,
      meta: {
        title: 'Waters Contracting - Payments'
      }
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
});



router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  next();
});


export default router;